<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><a href="/item-table">{{ $t('product.catalogue') }}</a></li>
					<li><span>{{ $t('import') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-10 col-sm-offset-1">
				<div id="import-form" class="form-open">
					<div class="row">
						<div class="col-sm-4">
							<select id="import-types" class="select">

							</select>
						</div>
						<div class="col-sm-4">
							<select id="import-templates" class="select">

							</select>
						</div>
						<div class="col-sm-4">
							<label for="import-sample">{{ $t('import.example') }}</label>
							<a id="import-sample"></a>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<input id="import-file" type="file" accept=".xls,.xlsx"/>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<button id="import-launcher" class="uk-button uk-button-primary uk-button-small"
									data-config-id="0" @click="importLauncherManager().launchImport()">{{ $t('upload.file') }}
							</button>
							<div id="upload-import-progress" class="hidden-element">
								<progress></progress>
								<span class="progress-percent"></span>
								<button class="button_reset fa fa-times"></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('reimport') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { ImportManager, getImportReport, importLauncher } from '@/core/migration/ImportManager'
import { resizeTableHeight, Table } from '@/core/support_gui_components/table/table'
import { getFormattedDateTime } from '@/core/shared'
import '@/core/input_controls/fileUploader/fileUploader'

export default {
	name: 'Import',
	metaInfo () {
		return {
			title: this.$t('import')
		}
	},
	methods: {
		importLauncherManager: function () {
			return importLauncher
		}
	},
	mounted () {
		let vm = this
		let tableColumns = [
			{
				'title': 'import.id',
				'columnName': 'id'
			},
			{
				'title': 'import.name',
				'columnName': 'name'
			},
			{
				'title': 'migration.user',
				'columnName': 'creator'
			},
			{
				'title': 'date',
				'columnName': 'date'
			},
			{
				'title': 'migration.source',
				'columnName': 'sourceUri'
			},
			{
				'title': 'import.status',
				'columnName': 'statusLbl'
			},
			{
				'title': 'migration.report',
				'columnName': 'reportUri'
			},
			{
				'title': 'debug.archive',
				'columnName': 'debug_link'
			}
		]

		$(':file').filestyle({ buttonText: vm.$t('choose.file') })

		let importManager = new ImportManager()
		importManager.loadImportHistory()
		importManager.loadImportConfigs()
		importManager.restoreLastState()

		window.importReport = function (id, status) {
			getImportReport(id, status)
		}

		this.$store.dispatch(USER_CONFIG, 'importsTable.tableState')
			.then((config) => {
				window.importHistoryTable = new Table('importsTable',
					{
						selector: '#table',
						columns: tableColumns,
						contextMenu: '#context-menu',
						importButton: true,
						restoringSupport: true,
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								importManager.resendImport(item.id)
							}
						}
					},
					function (data) {
						_.each(data, function (value, key) {
							var date = new Date(value['dateCreate'])
							value['date'] = getFormattedDateTime(date)

							var sourceUri = '/import/' + value['id'] + '/source'
							value['sourceUri'] = '<a onclick="downloadManager(\'' + sourceUri + '\')">' + 'import/' + value['id'] + '/source' + '</a>'

							if (value['status'] == true) {
								value['statusLbl'] = vm.$t('success')
								value['reportUri'] = '<a class="report-link" onclick=\'importReport(' + value['id'] + ',' + value['status'] + ')\'>' + vm.$t('migration.report') + '</a>'
							}
							if (value['status'] == false) {
								value['statusLbl'] = vm.$t('error')
								value['reportUri'] = '<a class="report-link" onclick=\'importReport(' + value['id'] + ',' + value['status'] + ')\'>' + vm.$t('migration.report') + '</a>'
							}
							if (value['status'] == null) {
								value['statusLbl'] = '<span class=\'loading fa fa-refresh fa-spin\'></span>'
							} else {
								if (value['debug'] == true) {
									value['debug_link'] = '<a onclick="downloadManager(\'/import/debug?importId=' + value['id'] + '\')">' + vm.$t('archive') + '</a>'
								}
							}
						})
					})
				importHistoryTable.setSavedState(config)
				importHistoryTable.setData(importManager.getImportHistory())
				importHistoryTable.initTable()

				importManager.checkAllImportSuccess(function (data) {
					importHistoryTable.updateData(data)
				})
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG importsTable', error)
			})

		$(window).resize(function () {
			resizeTableHeight()
			importHistoryTable.frozenTableElements.setFrozenHeaderCellsWidth()
		})
	}
}
</script>

<style scoped>

</style>
